import styled from 'styled-components'

export const Expand = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`
